import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import '../assets/css/icones/iconsmind/style.css';
import { obterMenuComPermissoes } from '../util/Configuracoes';

const Menu = props => {
    const obterAtivo = (props, item) => {
        let path = props.children.props.active ? props.children.props.active : props.children.props.path

        if (props.ativo === item.id || (props.ativo === "" && item.caminho === props.children.props.path))
            return true

        if (item.submenu && item.submenu.map((subItem) => subItem.caminho).includes(path))
            return true

        return false
    }

    const [menu, setMenu] = useState([]);

    useEffect(async () => {
        setMenu(await obterMenuComPermissoes())
    }, [])

    // useEffect(() => {
    //     console.log(menu)

    //     for (let i = 0; i < menu.length; i++)
    //         console.log(menu[i])
    // }, [menu])

    return (
        <ul className="nav menu table-wrapper-scroll-y custom-scrollbar" >

            {menu.filter(x => x.permitido).map((item, index) =>
                <li className="nav-item" key={index} >
                    <Link className={"nav-link" + (obterAtivo(props, item) ? ' menu-active' : '')} to={item.caminho ? item.caminho : '#'} data-flag={item.id} onClick={() => props.onClick(item.id)}>
                        <span className={"icone-menu " + item.icone}></span>
                        <span>{item.nome} </span>
                    </Link>
                </li>
            )}
        </ul>
    )
}

export { Menu } 